import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { PayoutModal } from "./payout-modal";
import { BonusProgress } from "@/components/ui/bonus-progress";
import { Loader2 } from "lucide-react";

interface IncentiveData {
  results: [
    {
      incentiveBonus: number;
      month: string;
      totalMonthlyEligibleTeens: number;
      caseload: number;
    },
  ];
}

export function MonthlyBonus({
  incentiveData,
  isLoading,
}: {
  incentiveData: IncentiveData;
  isLoading: boolean;
}) {
  const [open, setOpen] = useState(false);
  const currentMonthIncentives = incentiveData?.results?.[0];
  const currentMonth = currentMonthIncentives?.month;

  return (
    <>
      <Card
        onClick={() => setOpen(true)}
        className={cn(
          "h-[172px] cursor-pointer transition-all duration-200 hover:shadow-md",
          isLoading && "animate-pulse",
        )}
      >
        {isLoading ? (
          <div className="mb-4 flex items-center justify-center p-6">
            <Loader2 className="h-4 w-4 animate-spin" />
          </div>
        ) : (
          <CardContent className="flex flex-col items-start gap-6 p-4">
            <h3 className="font-['TWK Lausanne'] text-s font-normal leading-4 text-[#777]">
              Monthly Bonus
            </h3>

            <BonusProgress
              totalMonthlyEligibleTeens={
                currentMonthIncentives?.totalMonthlyEligibleTeens
              }
              caseload={currentMonthIncentives?.caseload}
            />
          </CardContent>
        )}
      </Card>
      <PayoutModal
        open={open}
        currentMonth={currentMonth}
        onClose={() => setOpen(false)}
        incentiveData={incentiveData}
        caseload={currentMonthIncentives?.caseload}
      />
    </>
  );
}
